module.exports = __webpack_public_path__ + "img/watchFooter.17089f15.svg";